import { style } from 'typestyle'
import { important } from 'csx'
export const f16i = style({ fontSize: important('16px') })
